import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs';
import { selectUser, userActions } from '@redux/user.effects';

@Directive({
  selector: '[appAvatar]',
  standalone: true,
})
export class AvatarDirective implements OnInit, OnChanges {
  @Input('appAvatar') userId!: string | null;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private store: Store,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userId'] && !changes['userId'].isFirstChange()) {
      this.loadAvatar();
    }
  }

  ngOnInit() {
    if (this.userId) {
      this.loadAvatar();
    }
  }

  private loadAvatar() {
    this.store
      .select(selectUser.avatars)
      .pipe(
        filter((avatars) => !!avatars[this.userId!]),
        take(1),
      )
      .subscribe((avatars) => {
        const avatarUrl = avatars[this.userId!];
        this.setAvatar(avatarUrl);
      });

    this.store.dispatch(userActions.avatar({ userId: this.userId! }));
  }

  private setAvatar(url: string) {
    this.el.nativeElement.src = url;
  }
}
